import { combineEpics } from 'redux-observable';
import login from './login';
import logout from './logout';
import verifyUser from './verifyUser';
import forgotPassword from './forgotPassword';
import resetPassword from './resetPassword';
import updateUser from './updateUser';
import changePassword from './changePassword';

export const userEpic = combineEpics(
  login,
  logout,
  verifyUser,
  forgotPassword,
  resetPassword,
  updateUser,
  changePassword,
);
